



















































































/* General */
import Vue from 'vue'
import ProjectSettingsLayout from '@/layouts/project-settings-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'
import ProjectSettingsDescriptionTemplatesTemplate from './components/project-settings-description-templates-template.vue'

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */

/* API */
import InternalProjectsAPI from '@/api/modules/internal-projects.api'
import { IDescriptionTemplate } from '@/api/types/response.types'
import {
  IInternalProjectsInputCreateDescriptionTemplate,
  IInternalProjectsInputUpdateDescriptionTemplate,
} from '@/api/types/request.types'

export default Vue.extend({
  name: 'ProjectSettingsDescriptionTemplates',

  metaInfo(): any {
    return {
      title: `Description Templates - ${this.name}`,
    }
  },

  components: {
    ProjectSettingsLayout,
    ProjectSettingsDescriptionTemplatesTemplate,
    EntitySettingsLoading,
  },

  data() {
    return {
      ColorAssistant,
      isLoading: true,
      isSubmitting: false,
      editingID: null,
      name: '',
      descTemplates: [] as IDescriptionTemplate[],
      upsertingDescTemplate: {} as IDescriptionTemplate,
      modalOpened: false,
      rules: {
        title: [
          {
            required: true,
            trigger: 'submit',
            message: 'Title is required',
          },
        ],
        template: [
          {
            required: true,
            trigger: 'submit',
            message: 'Template is required',
          },
        ],
      },
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
    isEditing(): boolean {
      return this.editingID != null
    },
    hasDescTemplates(): boolean {
      return this.descTemplates.length > 0
    },
  },

  watch: {
    modalOpened(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          // @ts-ignore
          this.$refs.savedTemplateForm_Title.focus()
        })
      }
    },
  },

  async created() {
    this.isLoading = true
    await this.getDescriptionTemplatesInfo()
    this.isLoading = false
  },

  methods: {
    getDescTemplate(id: number) {
      return this.descTemplates.find(dt => dt.id === id)
    },
    async getDescriptionTemplatesInfo() {
      try {
        const response = await InternalProjectsAPI.get_DescriptionTemplates(
          this.id,
        )
        this.name = response.name
        this.descTemplates = response.listDescriptionTemplates
      } catch (error) {
        this.$error.emit(error)
      }
    },
    async upsertTemplate() {
      // @ts-ignore
      this.$refs.upsertTemplateForm.validate((valid: boolean) => {
        if (valid) {
          this.isEditing
            ? this.updateDescriptionTemplate()
            : this.createDescriptionTemplate()
          this.closeModal()
        }
      })
    },

    beginEditTemplate(id: number): void {
      this.upsertingDescTemplate = this.getDescTemplate(id)
      this.modalOpened = true
      this.editingID = id
    },

    beginCreateTemplate(): void {
      this.upsertingDescTemplate = {} as IDescriptionTemplate
      this.modalOpened = true
      this.editingID = null
    },

    async removeTemplate(id: number) {
      await this.$confirm(
        `Are you sure you want to delete this template?<br />
         This cannot be undone.`,
        {
          dangerouslyUseHTMLString: true,
          center: true,
          confirmButtonText: 'Yes, Delete',
          confirmButtonClass: 'el-button--strawberry',
          cancelButtonText: 'Cancel',
          cancelButtonClass: 'el-button--text',
          type: 'warning',
          title: `Delete Description Template`,
        },
      )
      await this.deleteDescriptionTemplate(id)
    },

    closeModal(): void {
      this.modalOpened = false
      // @ts-ignore
      this.$refs.upsertTemplateForm.clearValidate()
    },

    async createDescriptionTemplate() {
      try {
        this.isSubmitting = true
        const data = this
          .upsertingDescTemplate as IInternalProjectsInputCreateDescriptionTemplate
        const response = await InternalProjectsAPI.post_CreateDescriptionTemplate(
          this.id,
          data,
        )
        this.$messaging.showSuccess(response.message)
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        await this.getDescriptionTemplatesInfo()
        this.isSubmitting = false
      }
    },

    async updateDescriptionTemplate() {
      try {
        this.isSubmitting = true
        const data = this
          .upsertingDescTemplate as IInternalProjectsInputUpdateDescriptionTemplate
        const response = await InternalProjectsAPI.put_UpdateDescriptionTemplate(
          this.id,
          this.editingID,
          data,
        )
        this.$messaging.showSuccess(response.message)
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        await this.getDescriptionTemplatesInfo()
        this.isSubmitting = false
      }
    },

    async deleteDescriptionTemplate(id: number) {
      try {
        this.isSubmitting = true
        const response = await InternalProjectsAPI.delete_DeleteDescriptionTemplate(
          this.id,
          id,
        )
        this.$messaging.showSuccess(response.message)
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        await this.getDescriptionTemplatesInfo()
        this.isSubmitting = false
      }
    },
  },
})
